import dayjs from 'dayjs';

const KEY_FORMAT = 'YYYY-MM-DD';

const getWindowEdge = (keys, compare) => keys.reduce((selected, key) => (
  compare(key, selected) ? key : selected
), keys[0]);

const findClosestAvailableDate = (availability, target, opts = {}) => {
  const keys = Object.keys(availability);
  if (keys.length === 0) return null;

  const direction = opts.direction || 'forward';
  const targetDay = dayjs(target).startOf('day');
  const lowerBound = opts.lowerBound ? dayjs(opts.lowerBound).startOf('day') : null;
  const maxDate = opts.maxDate ? dayjs(opts.maxDate).startOf('day') : null;
  const firstDay = dayjs(getWindowEdge(keys, (key, selected) => key < selected), KEY_FORMAT)
    .startOf('day');
  const lastDay = dayjs(getWindowEdge(keys, (key, selected) => key > selected), KEY_FORMAT)
    .startOf('day');
  const upperLimit = maxDate && maxDate.isBefore(lastDay, 'day') ? maxDate : lastDay;

  const isCandidate = (day) => {
    if (lowerBound && !day.isAfter(lowerBound, 'day')) return false;
    if (day.isBefore(firstDay, 'day') || day.isAfter(upperLimit, 'day')) return false;

    const entry = availability[day.format(KEY_FORMAT)];
    return Boolean(entry && entry.available);
  };

  if (direction === 'forward') {
    let cursor = targetDay;
    while (!cursor.isAfter(upperLimit, 'day')) {
      if (isCandidate(cursor)) return cursor.toDate();
      cursor = cursor.add(1, 'day');
    }
    return null;
  }

  const maxOffset = Math.max(
    targetDay.diff(firstDay, 'day'),
    upperLimit.diff(targetDay, 'day')
  );

  for (let offset = 0; offset <= maxOffset; offset += 1) {
    const forward = targetDay.add(offset, 'day');
    if (isCandidate(forward)) return forward.toDate();

    if (offset > 0) {
      const backward = targetDay.subtract(offset, 'day');
      if (isCandidate(backward)) return backward.toDate();
    }
  }

  return null;
};

export default findClosestAvailableDate;
